import { render, staticRenderFns } from "./closure-responsible.vue?vue&type=template&id=338cfdfe"
import script from "./closure-responsible.vue?vue&type=script&lang=js"
export * from "./closure-responsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports